import { SwipeableDrawer } from '@mui/material';
import { Close } from 'components/icons';
import { useAuth } from 'hooks';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';

import ActiveLink from '../ActiveLink';
import RenderIf from '../RenderIf';

import './MobileMenu.css';

const useStyles = createUseStyles({
  drawer: {
    '& .MuiDrawer-paper': {
      maxWidth: '375px',
      width: '100%',
    },
  },
});
const MobileMenu = ({ open, onHide }) => {
  const classes = useStyles();

  const isAuth = useAuth();
  const { t } = useTranslation();

  return (
    <SwipeableDrawer
      open={open}
      onClose={() => onHide(false)}
      onOpen={() => null}
      className={classes.drawer}
    >
      <div className="mobile-menu__title">
        <button
          onClick={() => onHide(false)}
          className="mobile-menu__close-button"
        >
          <Close />
        </button>
        <Link to="/" className="mobile-menu__logo">
          <img src="/media/1x2-logo.svg" alt="1x2" />
        </Link>
      </div>
      <ul className="mobile-menu__list">
        <li>
          <ActiveLink to="/" activeClassName="mobile-menu__active">
            {t('HOME')}
          </ActiveLink>
        </li>
        <li>
          <ActiveLink to="/bron" activeClassName="mobile-menu__active">
            {t('BRON')}
          </ActiveLink>
        </li>
        <li>
          <ActiveLink to="/circulations" activeClassName="mobile-menu__active">
            {t('CIRCULATIONS')}
          </ActiveLink>
        </li>
        <li>
          <ActiveLink to="/results" activeClassName="mobile-menu__active">
            {t('RESULTS')}
          </ActiveLink>
        </li>

        <RenderIf condition={Boolean(isAuth)}>
          <li>
            <ActiveLink to="/my-tickets" activeClassName="mobile-menu__active">
              {t('MY_TICKETS')}
            </ActiveLink>
          </li>
          <li>
            <ActiveLink
              to="/my-bron-tickets"
              activeClassName="mobile-menu__active"
            >
              {t('MY_BRON_COUPONS')}
            </ActiveLink>
          </li>
        </RenderIf>
      </ul>
      <RenderIf condition={!isAuth}>
        <div
          className="d-flex align-items-center mt-4 gap-3 "
          style={{ paddingInline: '30px' }}
        >
          <Link
            to="/auth/login"
            className="header__button header__button--primary"
          >
            {t('LOGIN')}
          </Link>
          <Link
            to="/auth/register"
            className="header__button header__button--primary"
          >
            {t('REGISTER')}
          </Link>
        </div>
      </RenderIf>
    </SwipeableDrawer>
  );
};

export default MobileMenu;
